import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
    selector: 'isto-spinner',
    imports: [
        MatDialogModule
    ],
    templateUrl: './spinner.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './spinner.component.scss'
})
export class SpinnerComponent {

}
